// import React from 'react';
import ExamList from '@/pages/exam';
import Garment from '@/pages/Garment';
import Home from '@/pages/Home'
import Login from '@/pages/view/login';

export interface RouterType {
    breadcrumb_name:string;
    path:string;
    component:any,
    icon?:string;
    unShow?:boolean;
    children?:Array<RouterType>
    props?:Object;
    key?:string;
    label?:string;
}
export const router:Array<RouterType> = [
    {
        breadcrumb_name:'项目管理',
        path: '/login',
        component:()=><Login />,
        icon:'',
        
    },
    {
        breadcrumb_name:'试题库',
        path: '/exam',
        component:()=><ExamList />,
        icon:'',
        children: [
            {
                breadcrumb_name:'项目权限',
                path: '/project/list122',
                component:()=><Home />,
                icon:''
            }
        ]
    },
    
];
// 路由树拍平成一级处理
export const routerViewList=()=>{
    let routerList:any =[]
    function format(routerAry: any,parentPath: string) {
        routerAry.forEach((item:RouterType)=>{
            if(item.children?.length){
                format(item.children, item.path)
            }
            routerList.push({...item,parentPath})
        })
    }
    format(router,'/')    
    return routerList
}
// 根据当前路由查找全路径
export const routerPathList = (path:string) => {
    let routerList =routerViewList();
    let pathList:string[] = []
    function format(path_:string) {
        let parentItem:any = routerList.filter((item:any)=>item.path === path_)[0] || {}
        pathList.unshift(parentItem.path)
        if(parentItem?.parentPath && parentItem?.parentPath !== '/') {
            format(parentItem?.parentPath)
        }
    }
    format(path)
    return pathList
}
// 路由映射处理
export const routerFormat = () => {
    function format(routerAry: any) {
       return routerAry.map((item:RouterType) => {
            const { breadcrumb_name, path, children } = item
            if (children?.length) {
                format(item.children)
            }
            item.key=path
            item.label=breadcrumb_name
            return item
        })
    }
    return format(router)

}